export const FETCH_EVENT_REQUEST = "FETCH_EVENT_REQUEST";
export const SET_BEFORE_ATTRIBUTES = "SET_BEFORE_ATTRIBUTES";
export const FETCH_EVENT_SUCCESS = "FETCH_EVENT_SUCCESS";
export const FETCH_EVENT_FAILURE = "FETCH_EVENT_FAILURE";
export const ADD_BUNDLE_IN_EVENT = "ADD_BUNDLE_IN_EVENT";
export const UPDATE_BUNDLE_IN_EVENT = "UPDATE_BUNDLE_IN_EVENT";
